module.exports = __webpack_public_path__ + "static/media/136.1b470845.jpg";